module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/spk/inputs/spk-currency/spk-currency.component.scss
// module id = ./src/app/components/framework/spk/inputs/spk-currency/spk-currency.component.scss
// module chunks = main